import { isNil } from "@clipboard-health/util-ts";
import { type ClipboardScorePolicy } from "@src/appV2/ClipboardScore/api/useGetClipboardScoreProfile";

export function getCancellationPointsChange(
  shiftLeadTimeInHours: number,
  policy: ClipboardScorePolicy
) {
  if (!policy) {
    return undefined;
  }

  const { cancelShift = [] } = policy;

  for (const { points, leadTime } of cancelShift) {
    const greaterThanEqualToIntervalStart =
      typeof leadTime[0] === "number" && leadTime[0] <= shiftLeadTimeInHours;
    const lessThanEqualToIntervalEnd =
      (typeof leadTime[1] === "number" && shiftLeadTimeInHours <= leadTime[1]) ||
      isNil(leadTime[1]);
    if (greaterThanEqualToIntervalStart && lessThanEqualToIntervalEnd) {
      return points;
    }
  }

  return undefined;
}

export function getRestrictionInDays(clipboardScore: number, policy: ClipboardScorePolicy) {
  if (!policy) {
    return undefined;
  }

  const { restriction = [] } = policy;

  for (const { duration, score } of restriction) {
    const greaterThanEqualToIntervalStart =
      (typeof score[0] === "number" && score[0] <= clipboardScore) || isNil(score[0]);
    const lessThanEqualToIntervalEnd =
      (typeof score[1] === "number" && clipboardScore <= score[1]) || isNil(score[1]);
    if (greaterThanEqualToIntervalStart && lessThanEqualToIntervalEnd) {
      return duration;
    }
  }

  return undefined;
}
